import React, { useState, useEffect } from "react";
import { Lock, Check } from "lucide-react";
import api from "../api";
import { K } from "../theme";
import { Cd, Sec, Inp, Bt } from "../components";

export const FreezeWindowConfig = ({ setSaveMsg }) => {
  const [fw, setFw] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/leaves/freeze-window')
      .then(d => setFw(d || { enabled: false, start: "04-11", end: "04-15", message: "" }))
      .catch(() => setFw({ enabled: false, start: "04-11", end: "04-15", message: "" }));
  }, []);

  if (!fw) return null;

  const saveFw = async () => {
    setSaving(true);
    try {
      const d = await api.put('/api/leaves/freeze-window', fw);
      setFw(d);
      setSaveMsg?.("Freeze window saved");
      setTimeout(() => setSaveMsg?.(""), 3000);
    } catch (e) {
      setSaveMsg?.("Error: " + (e.message || "Failed"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Cd style={{ marginBottom: 14, borderLeft: `3px solid ${fw.enabled ? K.a : K.t3}` }}>
      <div className="flex items-center justify-between mb-[10px]">
        <Sec icon={Lock} title="Leave Application Freeze Window" />
        <label className="flex items-center gap-[6px] text-[14px] text-t1 cursor-pointer">
          <input type="checkbox" checked={!!fw.enabled} onChange={e => setFw({ ...fw, enabled: e.target.checked })} />
          <span>{fw.enabled ? "Enabled" : "Disabled"}</span>
        </label>
      </div>
      <div className="text-[14px] text-t2 mb-[10px]">Block leave applications whose dates fall within this annual window (e.g. financial year-end). Format: MM-DD.</div>
      <div className="grid grid-cols-[1fr_1fr_2fr] gap-[10px] mb-[10px]">
        <div><div className="text-[12px] text-t3 mb-[3px]">Start (MM-DD)</div><Inp value={fw.start} onChange={v => setFw({ ...fw, start: v })} placeholder="04-11" /></div>
        <div><div className="text-[12px] text-t3 mb-[3px]">End (MM-DD)</div><Inp value={fw.end} onChange={v => setFw({ ...fw, end: v })} placeholder="04-15" /></div>
        <div><div className="text-[12px] text-t3 mb-[3px]">Message shown to user</div><Inp value={fw.message || ""} onChange={v => setFw({ ...fw, message: v })} placeholder="Leave applications are frozen during the year-end window." /></div>
      </div>
      <Bt s="sm" icon={Check} disabled={saving} onClick={saveFw}>{saving ? "Saving..." : "Save Freeze Window"}</Bt>
    </Cd>
  );
};
